import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Olutayo Oyefeso</div>
            <div className="Exco-Tittle">Financial Secretary</div>
            <br />

            <div className="Excos-Bio">
              Olutayo Oyefeso Chartered member MCIPD and Chartered Member CMI{" "}
              <br /> <br />
              Olutayo is a seasoned HR professional and Change Catalyst with a
              passion for driving positive change within organisations. With
              extensive experience in the health and social care industry, she
              has successfully navigated complex environments, unionized
              workforces, and fast-paced settings. <br /> <br />
              She joined the Unilag Alumni in 2017 and currently a member of the
              Executive Committee and the financial secretary.
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
